import { render, staticRenderFns } from "./DecreeZoneIndex.vue?vue&type=template&id=a324a8d6&scoped=true"
import script from "./DecreeZoneIndex.vue?vue&type=script&lang=js"
export * from "./DecreeZoneIndex.vue?vue&type=script&lang=js"
import style0 from "./DecreeZoneIndex.vue?vue&type=style&index=0&id=a324a8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324a8d6",
  null
  
)

export default component.exports